/**
 * Created by ianva on 16/7/21.
 */

var React = require("react");
var _ = require("underscore");

var LoadingLayer = require('../cutil/LoadingLayer');

var GinNotify = require('../cutil/gin-notify/gin-notify');

var {ActionConstants, ElementConstants, EventConstants} = require("../Constants");

var UIStore = require("../store/UIStore");


var NotifyContainer = React.createClass({
    getInitialState(){
        return {
            message: ''
        }
    },
    componentWillMount(){
        UIStore.on(EventConstants.ADD_NOTIFY,(msg)=>{
            this.setState({
                message:  msg
            });
        })

    },
    render() {
        return (
            <GinNotify message={this.state.message} />
        );
    }
});
var LoadingLayerContainer = React.createClass({
    getInitialState(){
        return {
            isOpenLoading : false
        }
    },
    componentWillMount(){
        UIStore.on(EventConstants.LOADING_LAYER, ()=>{
            this.setState({
                isOpenLoading: true
            });
        });
    },
    render() {
        return (
            <LoadingLayer isOpen={ this.state.isOpenLoading } />
        );
    }
});

var DetailUIContainer = ()=>
    <div>
        <NotifyContainer/>
        <LoadingLayerContainer/>
    </div>

module.exports = DetailUIContainer;


/** WEBPACK FOOTER **
 ** ./script/UIContainer/DetailUIContainer.js
 **/